import React from 'react'
import { Button } from 'antd'

const StockInputIconButton = (props) => {
  const { icon, onClicHandler } = props
  return (
    <Button icon={icon} onClick={onClicHandler} size='small' shape='round' />
  )
}

export default StockInputIconButton
